import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  fire(event){
    event.currentTarget.click()
  }
}
